import { Navigate, createBrowserRouter } from "react-router-dom";
import { lazy } from "react";
import PublicRoute from "components/shared/routes/PublicRoute";
import PrivateRoute from "components/shared/routes/PrivateRoute";
import Login from "components/pages/login/Login";
import { PATH, PORTALS_NAMES } from "utils/constants";
import { useEffect } from "react";
import { UseSelector, useSelector } from "react-redux/es/hooks/useSelector";
// import Login from "components/pages/login/Login";
import HomeLayout from "components/layouts/homelayout/HomeLayout";
const type = JSON.parse(localStorage.getItem("permission"))
export const Routing = () => {
    const { roles, stock, load } = useSelector((state) => state.stock)
    // useEffect(() => {
    //     type = JSON.parse(localStorage.getItem('permission'));
    //     console.log('type', type);
    //     // Perform any logic or state updates based on type if needed
    // }, []);

    return createBrowserRouter([
        {
            //public routes
            path: "/login",
            element: <PublicRoute component={Login} />
        },
        // {
        //     //public routes
        //     path: "/forgotpassword",
        //     element: <PublicRoute component={Login} />
        // },
        // {
        //     //public routes
        //     path: "/new-password",
        //     element: <PublicRoute component={Login} />
        // },
        {
            //private routes
            path: "/",
            element: <PrivateRoute component={HomeLayout} />,
            children: [
                ...Object.values(PATH).filter(x => roles?.trend && roles?.tracker ? x.private : x.private && roles?.trend ? x.path == "/stocktrend" : x.path == "/stock" || x.path == "/stock/logs").map(portal => ({
                    path: portal.path,
                    element: portal.element,
                    children: [
                        ...Object.values(portal.children).map(child => ({
                            path: child.path,
                            element: child.element
                        }),

                        ),
                        // {
                        //     path: portal.path + "/",
                        //     element: <div>main</div>
                        // }

                    ]
                })),
                {
                    path: "/",
                    element: roles?.trend ? load ? null : stock?.length !== 0 ? <Navigate to={`/stocktrend/graph/${stock[0]?.id}`} /> : <Navigate to={"/stocktrend"} /> : <Navigate to={"/stock/logs"} />
                },
                // {
                //     path: "*",
                //     element: <Navigate to={"/"} />
                // },
            ]
        },
        {
            path: "*",
            element: <Navigate to="/" />
        },
    ])
}

